<i18n>
{
  "ja": {
    "h-1": "倉庫スペースを提供したい方へ",
    "lead": "使っていない倉庫スペースを:そのままにしていませんか？:\nWarexに登録すれば、:遊休スペースを活用して: :新たな収入源にすることが可能です。:"
  }
}
</i18n>

<template>
  <main class="main">
    <picture>
      <source srcset="@/assets/img/fortheowners/kv.jpg" media="(min-width: 768px)">
      <img src="@/assets/img/fortheowners/kv_sp.jpg" class="img" alt="">
    </picture>
    <div class="inner">
      <p class="text-sm md:text-2xl font-bold tracking-widest">倉庫をお持ちの方へ</p>
      <h1 class="ttl">
        <span>倉庫の空きスペース</span>を<br />
        <span>収益化</span>しませんか。
      </h1>
      <p class="mt-8">
        <a class="cta-btn md:p-4 md:text-3xl" href="https://warex.ai/contact" target="_blank">お問い合わせ</a>
      </p>
    </div>
  </main>
</template>

<style scoped lang="scss">
.main {
  @apply relative z-10 mt-8;
  @screen md {
    @apply py-20 px-4 m-0;
  }
}
.img {
  @apply absolute inset-0 w-full h-full object-cover object-center;
}
.inner {
  min-height: 530px;
  @apply relative w-full max-w-page mx-auto text-white px-6 overflow-hidden flex flex-col justify-center;
  @screen md {
    min-height: 0;
    @apply text-base px-0;
  }
}
.ttl {
  font-size: 28px;
  @apply text-white py-4 font-bold leading-loose tracking-normal whitespace-no-wrap;
  span {
    font-size: 32px;
    border-radius: 8px;
    border: 3px solid #02BDA9;
    @apply text-accent bg-white p-1 mr-1;
  }
  @screen md {
    font-size: 60px;
    @apply pt-2 pb-5 tracking-wider;
    span {
      font-size: 60px;
      border-radius: 12px;
      border: 4px solid #02BDA9;
      @apply px-4 py-1 mr-4;
    }
  }
}
</style>

<script>
export default {};
</script>
